import { useEffect } from 'react'
import { firestoreListenersManager } from '@/shared/lib/firestore-listeners-manager'
import { getFirestore, collection } from 'firebase/firestore'
import {
  mentionFromSnapshot,
  type DocumentSnapshot,
} from '@rundown-studio/types'
import { mentionsQueryKeys } from '../hooks'
import { useQueryClient } from '@tanstack/react-query'

type UseMentionsListenerParams = {
  rundownId: string
}

export const useMentionsListener = ({
  rundownId,
}: UseMentionsListenerParams) => {
  const queryClient = useQueryClient()

  useEffect(() => {
    const db = getFirestore()
    const collectionRef = collection(db, 'rundowns', rundownId, 'mentions')

    const unsubscribe = firestoreListenersManager.subscribeToCollection(
      collectionRef,
      (snapshot) => {
        queryClient.setQueryData(
          mentionsQueryKeys.list({ rundownId }).queryKey,
          snapshot.docs
            .map((doc) =>
              // @ts-expect-error Type is number
              mentionFromSnapshot(doc as unknown as DocumentSnapshot),
            )
            .sort((a, b) => a.key - b.key),
        )

        snapshot.docChanges().forEach((change) => {
          const mentionKey = mentionsQueryKeys.byMentionId({
            rundownId,
            mentionId: change.doc.id,
          }).queryKey

          if (change.type === 'removed') {
            void queryClient.removeQueries({ queryKey: mentionKey })
          } else {
            const mention = mentionFromSnapshot(
              change.doc as unknown as DocumentSnapshot,
            )

            queryClient.setQueryData(mentionKey, mention)
          }
        })
      },
    )

    return () => unsubscribe()
  }, [queryClient, rundownId])
}
